import { render, staticRenderFns } from "./CostBearersCreate.vue?vue&type=template&id=30bfce06"
import script from "./CostBearersCreate.vue?vue&type=script&lang=ts"
export * from "./CostBearersCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports